// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  SERVER: "http://localhost:8493/",
  // SERVER: "https://insure-dev.gventure.info:8491/",
  SIP_DOMAIN: "websocket.ringpilot.us",
  SERVERURL: "https://portal.ringpilot.us/assets/",
  RECORDRURL: "https://portal.ringpilot.us/recording/",
  CLIENTID: "319456839350-mfees7ec7q14snnp24j0adm59mbr5pcf.apps.googleusercontent.com",
  SISENSESERVER: "https://bi.portal.ringpilot.us",
  SSOKEY: "1d7633354d46c1211d076d29f149555a2b4dfffc6c1824509a87c72b9eba5705",
  VM_LOGIN: "https://portal.virtualmentor.us/nd_package",
  VM_ACCESS: "https://sfginsuranceapi.portal.ringpilot.us/insurance-search",
  VMSSO: "https://sfginsuranceapi.portal.ringpilot.us/api/cross-site-token",
  audioURL:'http://localhost:4200/assets/audiofile/',
};